import { observable, toJS } from "mobx";
import ControleEstoqueService from './../../../../services/ControleEstoqueService';
import { buscaSemResultado, buscaFiltrarVazio } from './../../../../utils/mensagens';
import { sortCaret } from './../../../comum/components/Icones';
import { formatarDataCustomHTML, formatarCnpj } from './../../../../utils/formatar';


export class ControleEstoqueStore {

    @observable clienteSelecionado;
    @observable dataEntradaInicial;
    @observable dataEntradaFinal;
    @observable dataDesovaInicial;
    @observable dataDesovaFinal;
    @observable dtBlFinalizInicial
    @observable dtBlFinalizFinal;
    @observable statusBlSelecionado;
    @observable modalidadeSelecionado;

    @observable carregandoClientes;
    
    @observable clientes;
    @observable statusBl;
    @observable modalidades;
    @observable estoque;

    @observable tableMessage;
    @observable loading;
    @observable colunas;
    @observable filtroSelecionado;
    @observable camposTabela;
    
    @observable mostrarCamposExibicao;

    constructor() {
        this.clienteSelecionado = null;
        this.statusBlSelecionado = null;
        this.modalidadeSelecionado = null;
        this.statusBl = [];
        this.clientes = [];
        this.estoque = [];
        this.modalidades = [{value:'I', label: 'Importação'}, {value:'C', label: 'Cabotagem'}];
        
        this.dataEntradaInicial = null;
        this.dataEntradaFinal = null;
        this.dataDesovaInicial = null;
        this.dataDesovaFinal = null;
        this.dtBlFinalizInicial = null;
        this.dtBlFinalizFinal = null;
        
        this.carregandoClientes = false;

        this.filtroSelecionado = 0;
        this.camposTabela = [];
        this.colunas = this.todasColunas;
        this.tableMessage = buscaFiltrarVazio;
        this.loading = false;

        this.mostrarCamposExibicao = false;

        this.service = new ControleEstoqueService();
        this.carregarCampos();
        
    }

    listarClientes = () => {
        this.carregandoClientes = true;
        this.service.ListarClientes().then(response => {
            if(response && response.data) {
                this.clientes = response.data.map(cliente => ({label: `${cliente.ApelidoCliente} - ${cliente.Cnpj ? formatarCnpj(cliente.Cnpj) : 'Sem CNPJ'}`, value: cliente.ClienteId}));
            }
        }).catch(err => {console.error(err)
        }).finally(() => {
            this.carregandoClientes = false;
        });
    }

    listarStatusBl = () => {
        this.carregandoClientes = true;
        this.service.ListarStatusBl().then(response => {
            if(response && response.data) {
                this.statusBl = response.data.map(status => ({label: status.Descr, value: status.Codigo}));
            }
        }).catch(err => {console.error(err)
        }).finally(() => {
            //this.carregandoClientes = false;
        });
    }

    listarEstoque = () => {
        this.loading = true;
        this.tableMessage = "";
        this.service.Listar(this.clienteSelecionado ? this.clienteSelecionado.value : "", 
            "",
            this.modalidadeSelecionado ? this.modalidadeSelecionado.value : "",
            this.formatData(this.dataEntradaInicial),
            this.formatData(this.dataEntradaFinal),
            this.formatData(this.dataDesovaInicial),
            this.formatData(this.dataDesovaFinal),this.formatData(this.dtBlFinalizInicial),this.formatData(this.dtBlFinalizFinal),this.statusBlSelecionado ? this.statusBlSelecionado.value : "").then(response => {
                if(response && response.data) {
                    this.estoque = response.data;
                    if(response.data.length > 0) {

                    } else {
                        this.tableMessage = buscaSemResultado;
                    }
                } else {
                    this.tableMessage = buscaSemResultado;
                }
            }).catch(err => {console.error(err); this.tableMessage = "Houve um erro na consulta."}
            ).finally(() => {this.loading = false});
    }

    formatData = (data) => {
        if(data) {
            return data.format("YYYY-MM-DD");
        } else {
            return null;
        }
    }

    selecionaCliente = (value) => {
        this.clienteSelecionado = value;
    }

    selecionaStatusBl = (value) => {
        this.statusBlSelecionado = value;
    }
    
    selecionaModalidade = (value) => {
        this.modalidadeSelecionado = value;
    }

    mudarDatasEntrada = (value) => {
        this.dataEntradaInicial = value.startDate;
        this.dataEntradaFinal = value.endDate;
    }

    mudarDatasDesova = (value) => {
        this.dataDesovaInicial = value.startDate;
        this.dataDesovaFinal = value.endDate;
    }
    
    mudarDatasBlFinaliz = (value) => {
        this.dtBlFinalizInicial = value.startDate;
        this.dtBlFinalizFinal = value.endDate;
    }

    abrirFiltros = () => {
        this.mostrarCamposExibicao = true;
    }

    carregarCampos = () => {
        this.loading = true

        Promise.all([
            this.service.ListarFiltros().then(response => {
                if (response.data.length) {
                    const campos = response.data; //.map(elem => JSON.parse(elem.ValorObjeto));

                    if (campos.indexOf(campos.find((elem) => JSON.parse(elem.ValorObjeto).valor === 1)) === -1) {
                        this.filtroSelecionado = 0;
                    } else {
                        this.filtroSelecionado = campos.indexOf(campos.find((elem) => JSON.parse(elem.ValorObjeto).valor === 1));
                    }

                    let camposResponse = JSON.parse(campos[this.filtroSelecionado].ValorObjeto);
                    if (camposResponse.dadosTabela.includes("Cod. Armador")) { // TODO apenas para alteração do padrão anterior remover quando for seguro
                        camposResponse = JSON.parse("{\"valor\":0,\"nome\":\"Padrão\",\"descricao\":\"\",\"dadosTabela\":[\"Container\",\"ArmId\"]}");
                    }

                    if (this.camposTabela.length === 0) {
                        this.camposTabela = camposResponse.dadosTabela;
                    }
                } else {
                    this.camposTabela = this.service.obrigatorioMovimentacao;
                }
                this.aplicarCampos();

            }).catch(error => console.log(error))
        ]).then(() => {
            this.loading = false
        }).catch(err => {
            console.log(err);
            this.loading = false
        })
    };

    aplicarCampos = () => {
        let campos = []
        if (this.camposTabela) {
            this.todasColunas.filter(campo => {
                if (this.camposTabela.indexOf(campo.dataField) !== -1) {
                    campos.push(campo)
                }
            })
        }
        this.colunas = campos
    }

    fecharPagCampos = (filtroSalvo) => {

        if (filtroSalvo) {
            this.mostrarCamposExibicao = false
            this.camposTabela = filtroSalvo.dadosTabela

            this.aplicarCampos()
            // this.carregarCampos()
        }

    }

    fecharSemSalvar = () => {
        this.mostrarCamposExibicao = false
        // this.carregarCampos()
    }

    // Ver a questão de fechar filtros
    // Aplicar filtros
    // Tentar entender pq em Movimentações tem outro lance de carregar campos

    getLista() {
        return this.estoque;
    }

    getListaCopia() {
        return toJS(this.estoque)
    }

    todasColunas = [
        {
            dataField:"Cliente",
            text:"Cliente",
            sort: true,
            sortCaret: sortCaret
        },
        // {
        //     dataField:"ClienteId",
        //     text:"Cliente Id",
        //     sort: true,
        //     sortCaret: sortCaret
        // },
        {
            dataField:"CnpjCliente",
            text:"CNPJ",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"Cntr",
            text:"Container",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"Ce",
            text:"CE",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"Documento",
            text:"Documento",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"TipoDocumento",
            text:"Tipo Documento",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"DocumentoDespacho",
            text:"Doc. Despacho",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"IndConsolidado",
            text:"Consolidado",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"CanalBl",
            text:"Canal Bl",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"CodRef",
            text:"Código REF",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"DataEntrada",
            text:"Data Entrada",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DataDesova",
            text:"Data Desova",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtAtraca",
            text:"Data Atracação",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtPrimeiraEntrada",
            text:"Primeira Entrada",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtSaidaCarga",
            text:"Dt Saida Carga",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtSaidaVazio",
            text:"Dt Saida Vazio",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtDemurrage",
            text:"Data Demurrage",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        // {
        //     dataField:"DtDesovaFt",
        //     text:"Data Desova Ft",
        //     sort: true,
        //     sortCaret: sortCaret,
        //     formatter: formatarDataCustomHTML
        // },
        // {
        //     dataField:"DtEntradaFt",
        //     text:"Data Entrada Ft",
        //     sort: true,
        //     sortCaret: sortCaret,
        //     formatter: formatarDataCustomHTML
        // },
        {
            dataField:"DtFreetime",
            text:"Data Freetime",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtLiberMapa",
            text:"Liberação Mapa",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtPresenCarga",
            text:"Presença Carga",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtSolicitDesova",
            text:"Solicitação Desova",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"DtVencPrimeiroPeriodo",
            text:"Vencimento Primeiro Periodo",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            dataField:"Freetime",
            text:"Freetime",
            sort: true,
            sortCaret: sortCaret
        },
        // {
        //     dataField:"LiberRfb",
        //     text:"Liberação RFB",
        //     sort: true,
        //     sortCaret: sortCaret
        // },
        {
            dataField:"LiberDocumental",
            text:"Liberação Documental",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"Lote",
            text:"Lote",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"Armador",
            text:"Armador",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"Navio",
            text:"Navio",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"PesoBalanca",
            text:"Peso Balança",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"PortoOrigem",
            text:"Porto Origem",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"QtdCarregada",
            text:"Qtd Carregada",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"QtdDiasArmaz",
            text:"Dias Armazenado",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"QtdEstoque",
            text:"Qtd Estoque",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"QtdPeriodoArmaz",
            text:"Qtd Periodo Armazenado",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"RefCliente",
            text:"Ref Cliente",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"Regime",
            text:"Regime",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"StatusDocPdco",
            text:"Status",
            sort: true,
            sortCaret: sortCaret
        },
        {
            dataField:"StatusBl",
            text:"Status Bl",
            sort: true,
            sortCaret: sortCaret
        },
         {
             dataField:"TfaCargaSoltaRecebAverb",
             text: "TFA Carga Solta Receb. Averb.",
             sort: true,
             sortCaret: sortCaret
         },
         {
             dataField:"TfaCntrRecebAverb",
             text: "TFA Cntr Receb. Averb.",
             sort: true,
             sortCaret: sortCaret
         },
        {
            dataField:"TipoCntr",
            text:"Tipo",
            sort: true,
            sortCaret: sortCaret
        },
    ]
}


// WEBPACK FOOTER //
// ./src/modules/consultas/estoque/stores/ControleEstoqueStore.js